import { useCallback } from "react";
import { useShallow } from "zustand/react/shallow";
import cx from "classnames";

import Toggle from "ds/components/Toggle";
import { ShiftSelectionAction } from "components/BulkActions/useShiftSelectionManager";

import { TableSelectionStore } from "../../store/useTableSelectionStore/types";
import styles from "./styles.module.css";

type TableCellContentSelectionProps = {
  selectionStore: TableSelectionStore;
  selectionId: string;
  hasMoreSelectionOptions?: boolean;
  shiftSelectionAction?: ShiftSelectionAction;
};

const TableCellContentSelection = ({
  selectionStore,
  selectionId,
  hasMoreSelectionOptions,
  shiftSelectionAction,
}: TableCellContentSelectionProps) => {
  const { selected, disabled, toggle, addSelected, removeSelected } = selectionStore(
    useShallow((state) => ({
      selected: state.selected.has(selectionId),
      disabled: state.disabledIds.has(selectionId),
      toggle: state.toggle,
      addSelected: state.addSelected,
      removeSelected: state.removeSelected,
    }))
  );

  const onChange = useCallback(
    (isSelected: boolean) => {
      if (shiftSelectionAction) {
        const ids = shiftSelectionAction(selectionId);
        if (isSelected) {
          addSelected(ids);
        } else {
          removeSelected(ids);
        }
      } else {
        toggle(selectionId);
      }
    },
    [shiftSelectionAction, selectionId, addSelected, removeSelected, toggle]
  );

  return (
    <Toggle
      isDisabled={disabled}
      variant="checkbox"
      isSelected={selected}
      onChange={onChange}
      className={cx({ [styles.hasMoreSelectionOptions]: hasMoreSelectionOptions })}
    />
  );
};

TableCellContentSelection.displayName = "DS.Table.CellContent.Selection";

export default TableCellContentSelection;
